<template>
  <router-view />
</template>
<script>
export default {
  name: 'Anomalies',
};
</script>
